// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
Vue.use(ElementUI);
// import EventBus from "./EventBus";
// import EventBus from "@/event-bus";

// Vue.use(EventBus);
/* 路由 */
import router from "./router";

/* axios */
import axios from "./api";
import api from "./api/api";
Vue.prototype.http = axios;
Vue.prototype.api = api;

// import Vue from "vue";
// import Vuex from "vuex";
// import App from "./App.vue";
// import store from "./store"; // 假设 store 是你的 Vuex store

// Vue.use(Vuex);

// new Vue({
//   // 将 store 注入到所有的子组件中
//   store,
//   render: (h) => h(App),
// }).$mount("#app");

/* swiper */
import "swiper/dist/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
// import './styles/main.less';

// import "./assets/js/bootstrap.min";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "animate.css/animate.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// import Vue from "vue";
import VueEventBus from "vue-event-bus";

Vue.use(VueEventBus);
// const EventBus = new Vue();
// Object.defineProperties(Vue.prototype, {
//   $bus: {
//     get: function () {
//       return EventBus;
//     },
//   },
// });
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
/* animate.css */
import "animate.css";
//import 'animate.css'//导入animate.css
// import WOW from "wow.js";

// new WOW({
//   animateClass: "animate__animated",
// }).init();
import wow from "wowjs"; //全局导入wow.js
Vue.prototype.$wow = wow; //全局注册到Vue实例中
// wow.init(); //初始化wow.js
// import VueIntersectionObserver from "vue-intersection-observer";
// 正确的导入路径
// import VueIntersectionObserver from "vue-intersection-observer/dist/vue-intersection-observer.js";
// Vue.use(VueIntersectionObserver);
/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js